import React, { useContext, useState } from "react";
import { ShopContext } from "../Context/ShopContext";
import { useNavigate } from "react-router-dom";
import PayPalButton from "../Components/PayPalButton";
import "./CSS/Checkout.css";

const Checkout = () => {
  const { allProducts, cartItems, getTotalCartAmount } =
    useContext(ShopContext);

  const SHIPPING_FEE = 4.99;

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [paymentError, setPaymentError] = useState("");

  const navigate = useNavigate();

  // 🔹 Calculations
  const subtotal = getTotalCartAmount();
  const totalAmount = subtotal + SHIPPING_FEE;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    setErrors((prev) => ({ ...prev, ...validateForm() }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "First name required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name required";
    if (!formData.email.trim()) newErrors.email = "Email required";
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Enter a valid email";
    if (!formData.phone.trim()) newErrors.phone = "Phone required";
    if (!formData.address.trim()) newErrors.address = "Address required";
    return newErrors;
  };

  const isFormValid = Object.keys(validateForm()).length === 0;

  const handleSuccess = () => {
    setPaymentError("");
    navigate("/order-success");
  };

  const handleError = (err) => {
    console.error(err);
    setPaymentError(err?.message || "Payment failed. Please try again.");
  };

  if (!allProducts) return <p>Loading...</p>;

  return (
    <div className="checkout">
      <h1>Checkout</h1>

      <div className="checkout-container">
        {/* LEFT SIDE */}
        <div className="checkout-left">
          <h3>Billing Details</h3>

          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched.firstName && errors.firstName && (
            <p className="error">{errors.firstName}</p>
          )}

          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched.lastName && errors.lastName && (
            <p className="error">{errors.lastName}</p>
          )}

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched.email && errors.email && (
            <p className="error">{errors.email}</p>
          )}

          <input
            type="text"
            name="phone"
            placeholder="Phone"
            value={formData.phone}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched.phone && errors.phone && (
            <p className="error">{errors.phone}</p>
          )}

          <textarea
            name="address"
            placeholder="Shipping Address"
            value={formData.address}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched.address && errors.address && (
            <p className="error">{errors.address}</p>
          )}
        </div>

        {/* RIGHT SIDE */}
        <div className="checkout-right">
          <h3>Your Order</h3>

          {allProducts.map((item) => {
            if (cartItems[item.id] > 0) {
              return (
                <div key={item.id} className="checkout-item">
                  <p>
                    {item.name} × {cartItems[item.id]}
                  </p>
                  <span>£{item.new_price * cartItems[item.id]}</span>
                </div>
              );
            }
            return null;
          })}

          <hr />

          <div className="checkout-summary">
            <p>Subtotal: <strong>£{subtotal}</strong></p>
            <p>Shipping: <strong>£{SHIPPING_FEE}</strong></p>
            <p className="checkout-total">
              Total: <strong>£{totalAmount}</strong>
            </p>
          </div>

          {paymentError && (
            <p style={{ color: "red", marginTop: "8px" }}>{paymentError}</p>
          )}

          <div style={{ marginTop: "16px" }}>
            <PayPalButton
              customer={formData}
              items={cartItems}
              totalAmount={totalAmount}
              disabled={!isFormValid}
              onSuccess={handleSuccess}
              onError={handleError}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
